import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { MAIN_BUTTONS } from "../data/main-buttons";
import _ from "lodash";
import { store } from "../../components/Store";

/**
 * Componente que muestra los botones en la sección principal de ayuda
 * @param {object} interfaceTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} MainHelp
 */
export const MainHelp = ({ interfaceTexts }) => {

    const globalState = useContext(store);
    const { state } = globalState;
    const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";
    const buttons = [...MAIN_BUTTONS];

    return <>
        <h2>{interfaceTexts?.titulo || 'Encuentra el tutorial perfecto para ti'}</h2>

        <div className="d-flex flex-wrap mt-4">
            {
                buttons.map((btn) => {
                    if (isLogged) {
                        return (
                            <div
                                key={btn?.id}
                                className="col-sm-6"
                            >
                                <Link to={btn?.url} className="btn-tutorial-ayuda">
                                    <div className="i-btn-tuto">
                                        <Icon className="i-tuto" icon={btn?.icon} />
                                    </div>
                                    {_.get(interfaceTexts, btn?.name?.translationPath) || btn?.name?.default}
                                </Link>
                            </div>
                        )
                    } else {
                        if (btn?.id !== "perfil") {
                            return (
                                <div
                                    key={btn?.id}
                                    className="col-sm-6"
                                >
                                    <Link to={btn?.url} className="btn-tutorial-ayuda">
                                        <div className="i-btn-tuto">
                                            <Icon className="i-tuto" icon={btn?.icon} />
                                        </div>
                                        {_.get(interfaceTexts, btn?.name?.translationPath) || btn?.name?.default}
                                    </Link>
                                </div>
                            )
                        }
                    }

                })
            }
        </div>
    </>
}